
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Tabs,
  Tab,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./MapDeviceToSite.css";
import apiService from "../../utils/apiservice";


const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const MapDeviceToSite = () => {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [assignedDevices, setAssignedDevices] = useState([]);
  const [availableDevices, setAvailableDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const token = localStorage.getItem("accessToken");
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Reset to first page when changing tabs or sites
  useEffect(() => {
    setPage(0);
  }, [tabValue, selectedSite]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getConfig = () => ({
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: {},
  });

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await apiService({
          url: `/api/get_customers/`,
          method: "GET",
          data: {},
        });

        const customerData = res.data || [];
        setCustomers(customerData);

        if (customerData.length > 0) {
          setSelectedCustomer(customerData[0].tb_customer_id);
        }
      } catch (err) {
        toast.error("Failed to fetch customers");
      }
    };

    fetchCustomers();
  }, []);
  // Fetch sites on load
  useEffect(() => {
    const fetchSites = async () => {
      try {
        const res = await apiService({
          url: `/api/get_customer_sites/${selectedCustomer}/`,
          method: "GET",
          data: {}, // ✅ keep
        });
        const sitesData = res.data.data || [];
        setSites(sitesData);

        if (sitesData.length > 0) {
          const defaultSiteId = sitesData[0].asset_id;
          setSelectedSite(defaultSiteId);
          fetchDevices(defaultSiteId);
        }
      } catch (err) {
        toast.error("Failed to fetch sites");
      }
    };
    if (selectedCustomer) fetchSites();
  }, [selectedCustomer]);

  // const fetchDevices = async (siteId) => {
  //   try {
  //     setLoading(true);

  //     // 1️⃣ Fetch assigned devices for the selected site
  //     // const assignedResp = await axios.get(
  //     //   `${API_URL}/api/site_devices/${siteId}/`,
  //     //   {
  //     //     headers: {
  //     //       Authorization: `Bearer ${token}`,
  //     //       Accept: "application/json",
  //     //       "Content-Type": "application/json",
  //     //     },
  //     //     data: {}, // sometimes required by your backend
  //     //   }
  //     // );
  //     const assignedResp = await apiService({
  //       url: `/api/site_devices/${siteId}/`,
  //       method: "GET",
  //       data: {}, // ✅ keep
  //     });

  //     const assigned = (assignedResp.data.devices || []).map((d) => ({
  //       id: d.device_id,
  //       name: d.device_name,
  //       isAssigned: true,
  //     }));
  //     setAssignedDevices(assigned);

  //     // 2️⃣ Fetch available devices for the customer
  //     // Using the exact API call from your commented working code
  //     // const availableResp = await axios.get(
  //     //   `${API_URL}/api/customer_availabledevices/${customerId}/`,
  //     //   {
  //     //     params: { page: 0, pageSize: 100 },
  //     //     headers: {
  //     //       Authorization: `Bearer ${token}`,
  //     //       Accept: "application/json",
  //     //     },
  //     //     data: {}, // keep empty body if backend expects it
  //     //   }
  //     // );

  //     const availableResp = await apiService({
  //       url: `/api/customer_availabledevices/${selectedCustomer}/`,
  //       method: "GET",
  //       params: { page: 0, pageSize: 1000 }, // ✅ keep params
  //       data: {}, // ✅ keep
  //     });

  //     // const available = (availableResp.data.data?.data || [])
  //     //   .filter((d) => !assigned.some((ad) => ad.id === d.id.id)) // remove already assigned
  //     //   .map((d) => ({
  //     //     id: d.id.id,
  //     //     name: d.name,
  //     //     isAssigned: false,
  //     //   }));

  //     const availableList = availableResp.data.data || availableResp.data || [];

  //     const available = availableList
  //       .filter((d) => !assigned.some((ad) => ad.id === d.id))
  //       .map((d) => ({
  //         id: d.id,
  //         name: d.name,
  //         isAssigned: false,
  //       }));
  //     setAvailableDevices(available);
  //   } catch (err) {
  //     toast.error("Failed to fetch devices");
  //     setAssignedDevices([]);
  //     setAvailableDevices([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


// const fetchDevices = async (siteId) => {
//   try {
//     setLoading(true);

//     // =========================
//     // 1️⃣ ASSIGNED DEVICES API
//     // =========================
//     const assignedResp = await apiService({
//       url: `/api/site_devices/${siteId}/`,
//       method: "GET",
//       data: {},
//     });

//     console.log("ASSIGNED RAW:", assignedResp);

//     // ✅ FIX: correct axios structure handling
//     const assignedList =
//       assignedResp?.data?.devices ||
//       assignedResp?.devices ||
//       [];

//     const assigned = assignedList.map((d) => ({
//       id: d.device_id,
//       name: d.device_name,
//       isAssigned: true,
//     }));

//     setAssignedDevices(assigned);

//     // =========================
//     // 2️⃣ AVAILABLE DEVICES API
//     // =========================
//     let availableResp = null;

//     try {
//       availableResp = await axios.get(
//         `${API_URL}/api/customer_availabledevices/${selectedCustomer}/`,
//         {
//           params: { page: 0, pageSize: 100 },
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json",
//           },
//           data:{}
//         }
//       );
//     } catch (err) {
//       console.error("AVAILABLE API FAILED:", err);
//       toast.error("Available devices API failed (check backend)");
//       availableResp = { data: { data: [] } }; // fallback
//     }

//     console.log("AVAILABLE RAW:", availableResp);

//     // =========================
//     // 3️⃣ NORMALIZE AVAILABLE DATA
//     // =========================
//     const availableList =
//       availableResp?.data?.data?.data ||
//       availableResp?.data?.data ||
//       availableResp?.data ||
//       [];

//     // =========================
//     // 4️⃣ FIX THINGSBOARD ID ISSUE
//     // =========================
//     const getId = (d) => d?.id?.id || d?.id;

//     const available = availableList
//       .filter((d) => !assigned.some((ad) => ad.id === getId(d)))
//       .map((d) => ({
//         id: getId(d),
//         name: d.name,
//         isAssigned: false,
//       }));

//     setAvailableDevices(available);

//   } catch (err) {
//     console.error(err);
//     toast.error("Failed to fetch devices");

//     setAssignedDevices([]);
//     setAvailableDevices([]);
//   } finally {
//     setLoading(false);
//   }
// };




const fetchDevices = async (siteId) => {
  try {
    setLoading(true);

    const res = await apiService({
      url: `/api/customer_availabledevices_for_site/${selectedCustomer}/`,
      method: "GET",
      data: {},
    });

    console.log("FULL RESPONSE:", res);

    const assignedList = res?.data?.assigned_devices || [];
    const unassignedList = res?.data?.unassigned_devices || [];

    // =========================
    // ASSIGNED DEVICES
    // =========================
    // const assigned = assignedList
    //   .filter(d => d.site_id === siteId || d.site_id) // keep safety
    //   .map((d) => ({
    //     id: d.id,
    //     name: d.name,
    //     site_id: d.site_id,
    //     site_name: d.site_name,
    //     isAssigned: true,
    //   }));

    const assigned = assignedList
  .filter(d => String(d.site_id) === String(siteId))
  .map(d => ({
    id: d.id,
    name: d.name,
    site_id: d.site_id,
    site_name: d.site_name,
    isAssigned: true,
  }));

    // =========================
    // UNASSIGNED DEVICES
    // =========================
    const available = unassignedList.map((d) => ({
      id: d.id,
      name: d.name,
      isAssigned: false,
    }));

    setAssignedDevices(assigned);
    setAvailableDevices(available);

  } catch (err) {
    console.error(err);
    toast.error("Failed to fetch devices");

    setAssignedDevices([]);
    setAvailableDevices([]);
  } finally {
    setLoading(false);
  }
};

  const handleSiteChange = (e) => {
    const siteId = e.target.value;
    setSelectedSite(siteId);
    fetchDevices(siteId);
  };

  const handleAction = async (device, action) => {
    const isAssign = action === "assign";
    const endpoint = isAssign ? "assign_device_to_site" : "unassign_device_site";

    try {
      await axios.post(`${API_URL}/api/${endpoint}/`, {
        asset_id: selectedSite,
        // device_id: device.id,
        device_id: device.device_id || device.id,
      }, getConfig());

      if (isAssign) {
        setAssignedDevices([...assignedDevices, { ...device, isAssigned: true }]);
        setAvailableDevices(availableDevices.filter(d => d.id !== device.id));
      } else {
        setAvailableDevices([...availableDevices, { ...device, isAssigned: false }]);
        setAssignedDevices(assignedDevices.filter(d => d.id !== device.id));
      }

      toast.success(`Device ${isAssign ? "assigned" : "unassigned"} successfully`);
    } catch (err) {
      toast.error(err.response?.data?.error || "Action failed");
    }
  };

  const getFilteredDevices = () => {
    if (tabValue === 1) return assignedDevices;
    if (tabValue === 2) return availableDevices;
    return [...assignedDevices, ...availableDevices];
  };

  return (
    <>
      <Paper className="main-card-ui">
        <Box className="header-row">
          <TextField
            select
            label="Select Customer"
            value={selectedCustomer}
            onChange={(e) => {
              setSelectedCustomer(e.target.value);
              setSelectedSite("");
              setAssignedDevices([]);
              setAvailableDevices([]);
            }}
            size="small"
            className="device-select-input"
          >
            {customers.map((customer) => (
              <MenuItem
                key={customer.tb_customer_id}
                value={customer.tb_customer_id}
              >
                {customer.customer_name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Select Site"
            value={selectedSite}
            onChange={handleSiteChange}
            size="small"
            className="device-select-input"
          >
            {sites.map((site) => (
              <MenuItem key={site.asset_id} value={site.asset_id}>{site.name}</MenuItem>
            ))}
          </TextField>

          <Box className="badge-container">
            <div className="status-badge assigned">Assigned: {assignedDevices.length}</div>
            <div className="status-badge available">Available: {availableDevices.length}</div>
          </Box>
        </Box>

        <Box className="tabs-wrapper">
          <Tabs
            value={tabValue}
            onChange={(e, v) => setTabValue(v)}
            centered
            className="custom-tabs"
            TabIndicatorProps={{ style: { display: "none" } }}
          >
            <Tab label="All" />
            <Tab label="Assigned" />
            <Tab label="Available" />
          </Tabs>
        </Box>

        <TableContainer className="table-container-ui orange-table">
          {loading ? (
            <Box textAlign="center" p={5}><CircularProgress /></Box>
          ) : (
            <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Device Name</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getFilteredDevices().length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center" style={{ padding: "20px", color: "#94a3b8" }}>
                      No devices found.
                    </TableCell>
                  </TableRow>
                ) : (
                  getFilteredDevices()
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((device) => (
                      <TableRow key={device.id}>
                        <TableCell align="center">{device.name}</TableCell>
                        <TableCell align="center">
                          {device.isAssigned ? (
                            <Button className="btn-unmap" onClick={() => handleAction(device, "unassign")}>
                              Unassign
                            </Button>
                          ) : (
                            <Button className="btn-map" onClick={() => handleAction(device, "assign")}>
                              Assign
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          )}


          {/* After </TableContainer> */}
          {!loading && getFilteredDevices().length > 0 && (
            <div className="pagination-bar">
              <div className="rows-select">
                Rows per page:
                <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                </select>
              </div>
              <div className="page-info">
                {page * rowsPerPage + 1}-
                {Math.min((page + 1) * rowsPerPage, getFilteredDevices().length)} of {getFilteredDevices().length}
              </div>
              <div className="page-arrows">
                <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
                <button
                  disabled={(page + 1) * rowsPerPage >= getFilteredDevices().length}
                  onClick={() => setPage(page + 1)}
                >
                  ›
                </button>
              </div>
            </div>
          )}
        </TableContainer>
      </Paper>

      <ToastContainer position="top-right" autoClose={2000} />
    </>
  );
};

export default MapDeviceToSite;